import { HighchartsReactProps } from 'highcharts-react-official'
import styles from './styles.module.scss'
import sharedConfig from '../sharedConfig'
import chartOptionsMerge from '../chartOptionsMerge'

const defaultConfig: HighchartsReactProps = {
  chart: {
    type: 'line',
  },
  legend: {
    labelFormatter: function () {
      return `<span class=${styles.legendItem}>${this.name}</span>`
    },
  },
  tooltip: {
    formatter: function () {
      let tipStr = ''
      // tipStr += '<b>' + this.series.name + '</b><br>'
      // tipStr += `<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>`
      tipStr += `<span class=${styles.tooltipLabelX}><span style="font-size:16px;color:${this.point.color}">\u25CF  </span>${this.point.x}</span><br>`
      tipStr += `<span class=${styles.tooltipLabelY} style="font-size:13px;"><span style="font-size:16px;color:transparent">\u25CF  </span><span>${this.point.y}</span></span>`
      return tipStr
    },
  },
  plotOptions: {
    series: {
      marker: {
        enabled: true,
        states: {
          hover: {
            enabled: true,
          },
        },
      },
    },
  },
}

export const defaultOptions = chartOptionsMerge(defaultConfig, sharedConfig)
